import { Route } from 'react-router-dom'
import LegalDocumentPage from './legal/LegalDocumentPage'

/** Shared public legal routes — mounted on Marketing, App, and Unified surfaces. */
export function publicLegalRouteElements() {
  return (
    <>
      <Route path="/privacy" element={<LegalDocumentPage documentKey="privacy" />} />
      <Route path="/terms" element={<LegalDocumentPage documentKey="terms" />} />
      <Route path="/refund" element={<LegalDocumentPage documentKey="refund" />} />
      <Route path="/billing" element={<LegalDocumentPage documentKey="billing" />} />
    </>
  )
}
